// src/components/Home/HeroCarousel.jsx
import React, { useState, useEffect } from "react";
import { FaShip, FaPlane, FaTruck, FaFileContract } from "react-icons/fa";
import "./HeroCarousel.css";

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      icon: <FaShip />,
      title: "Sea Freight Shipping",
      description:
        "Cost-efficient FCL/LCL with dependable ETAs and proactive milestone updates. EXW/FOB coordination, Port handling at Mombasa & ICD.",
      background:
        "linear-gradient(135deg, rgba(26, 115, 232, 0.9) 0%, rgba(26, 115, 232, 0.7) 100%)",
    },
    {
      icon: <FaPlane />,
      title: "Air Freight Shipments",
      description:
        "Priority uplift via JKIA with tight transit times and compliant documentation. Airline bookings & AWB, Urgent spares & perishables.",
      background:
        "linear-gradient(135deg, rgba(251, 188, 4, 0.9) 0%, rgba(251, 188, 4, 0.7) 100%)",
    },
    {
      icon: <FaTruck />,
      title: "Road Transport",
      description:
        "Reliable trucking for port-to-ICD, last-mile and up-country deliveries. Container & loose cargo handling, Secure, GPS-tracked movements.",
      background:
        "linear-gradient(135deg, rgba(32, 33, 36, 0.9) 0%, rgba(32, 33, 36, 0.7) 100%)",
    },
    {
      icon: <FaFileContract />,
      title: "Customs Clearance & Brokerage",
      description:
        "Licensed KRA processes that reduce dwell time and prevent penalties. IDF, HS classification, permits (KEBS/PPB), Inspections & audit-ready documentation.",
      background:
        "linear-gradient(135deg, rgba(59, 130, 246, 0.9) 0%, rgba(59, 130, 246, 0.7) 100%)",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero-carousel">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${
              index === currentSlide ? "active" : ""
            }`}
            style={{ background: slide.background }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-icon">{slide.icon}</div>
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-description">{slide.description}</p>
                <div className="hero-buttons">
                  <button className="btn btn-primary">Get Free Quote</button>
                  <button className="btn btn-secondary">Learn More</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel Controls */}
      <button className="carousel-control prev" onClick={goToPrev}>
        ‹
      </button>
      <button className="carousel-control next" onClick={goToNext}>
        ›
      </button>

      {/* Carousel Indicators */}
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>

      {/* Overlay for better text readability */}
      <div className="hero-overlay"></div>
    </section>
  );
};

export default HeroCarousel;
